import { PageReqSchema } from '@/types/axios/public-json-structure'
import request, { baseURL } from '@/utils/request'
import { AxiosRequestConfig } from 'axios'
import { IAsrApi } from './type'

/**
 * 获取专业领域列表
 * @param language cn: 中文 eng: 英文
 * @param type 1: 离线转写 2：实时转写
 */
export function getAsrDomainOptionsApi(language: 'cn' | 'eng', type: 1 | 2) {
  return request.get<IAsrApi.IDomainOption[]>('/api/asr/properties', { params: { language, type } })
}

// 离线转写-开始转写
export function startOfflineAsrTaskApi(language: string, fileIdList: string[], property: string) {
  return request.post<string>('/api/asr/trans/submit', { language, fileIdList, property })
}

// 离线转写-获取进度
export function getOfflineAsrProgressApi(recordId: string, config?: AxiosRequestConfig) {
  return request.get<{ progress: number, failNum?: null | number, successNum?: null | number  }>('/api/asr/trans/progress', {
    params: { recordId },
    showMessageOnError: false,
    ...config
  })
}

// 离线转写-文件下载 URL
export function downloadOfflineAsrURL(recordId: string) {
  return baseURL + request.getUri({ url: '/api/asr/trans/download', params: { recordId } })
}

export function downloadOfflineAsrApi(recordId: string) {
  return request.get('/api/asr/trans/download', { params: { recordId }, responseType: 'blob' })
}

// 实时转写-生成记录id
export function getRecordIdApi(language: string) {
  return request.get<string>('/api/asr/ft/recordId', { params: { language } })
}

// 查询结果列表
export function getAsrResultList(params:PageReqSchema) {
  return request<IAsrApi.IListItem[]>({
    method: 'get',
    url: '/api/asr/page',
    params
  })
}

// 删除、批量删除
export function deleteResultApi(ids: string[]) {
  return request.post('/api/asr/delete', ids )
}

// 导出、批量导出
export const exportResultApi = (id: string, scope: IAsrApi.EnumExportType) => {
  return request({
    method: 'GET',
    url: '/api/asr/export',
    responseType: 'blob',
    showMessageOnError: false,
    params: {
      id,
      scope
    }
  })
}

// 实时转写-保存任务
export function saveAsrRtResultApi(params: IAsrApi.IAsrSaveReq) {
  return request.get(`/api/asr/ft/saveOrNot`, {
    params
  })
  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve({data: null})
  //   }, 10)
  // })
}

// 获取tts识别结果详情
export function getASRDetail(recordId: string) {
  return request.get<IAsrApi.ASRDetail>(`/api/asr/detail`, {params: { recordId }})
  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve({
  //       data: require('./mock.json')
  //     })
  //   }, 300)
  // })
}

// 获取识别进度
export const getProgressAPI = (params: { id: string }) => {
  return request.get<IAsrApi.IProgressRes[]>(`/api/asr/trans/progress`, { params, showMessageOnError: false })
}

// 根据详情返回的音频相对路径获取音频
export function getAudioByResultPath(audioPath: string) {
  // return request.get(`${audioPath}`, {
  //   responseType: 'blob'
  // })

  return baseURL + request.getUri({ url: `${audioPath}` })

  // return location.origin + '/temp/qhc.mp3'
}
